<header>
  <nav
    class="m-auto mt-0 w-screen xs:max-w-screen-xs sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl xxl:max-w-screen-xxl"
  >
    <div
      class="flex flex-row flex-wrap xl:max-w-screen-xxl mx-auto items-center justify-between px-4 pt-4 pb-2"
    >
      <div class="flex flex-row items-center justify-between">
        <a
          [routerLink]="['.']"
          [relativeTo]="activatedRoute"
          target="_self"
          class="flex items-center space-x-3"
        >
          <img
            src="assets/logo/almanjobs-logo-primary.svg"
            class="h-10 w-10"
            alt="Almanjobs logo"
            loading="lazy"
          />
        </a>
      </div>
      <div class="flex flex-row items-center justify-start">
        <div class="hidden relative md:flex justify-center items-center mx-2">
          <button
            [disabled]="(currentLocation |async) === 'employers'"
            type="button"
            #languageDropdownButton
            class="inline-flex items-center justify-center font-medium px-4 py-2 text-sm text-gray-900 dark:text-white rounded-md cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-white"
            [ngClass]="{
              'bg-gray-100 dark:bg-gray-700': (currentLocation |async) === 'employers'
            }"
          >
            <div
              id="tooltipContent"
              #tooltipContent
              role="tooltip"
              class="tooltip invisible absolute z-10 inline-block rounded-lg bg-gray-900 px-3 py-2 text-sm font-medium text-white opacity-0 shadow-sm transition-opacity duration-300 dark:bg-gray-700"
            >
              {{ tooltipLanguageButtonDisabledReason }}
              <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
            @if((activeLanguage | async) === 'fa'){
              <div class="inline-flex items-center">
                <img
                  class="w-5 h-5 rounded-full lg:me-3"
                  src="assets/icons/flags/fa.svg"
                  alt="iranian flag"
                  loading="lazy"
                />
                <span class="hidden lg:block">فارسی</span>
              </div>
            } @else if((activeLanguage | async) === 'de'){
              <div class="inline-flex items-center">
                <img
                  class="w-5 h-5 rounded-full lg:me-3"
                  src="assets/icons/flags/de.svg"
                  alt="german flag"
                  loading="lazy"
                />
                <span class="hidden lg:block">Deutsch</span>
              </div>
            } @else if((activeLanguage | async) === 'en') {
              <div class="inline-flex items-center">
                <img
                  class="w-5 h-5 rounded-full lg:me-3"
                  src="assets/icons/flags/en.svg"
                  alt="uk flag"
                  loading="lazy"
                />
                <span class="hidden lg:block">English</span>
              </div>
            } @else if((activeLanguage | async) === 'id') {
              <div class="inline-flex items-center">
                <img
                  class="w-5 h-5 rounded-full lg:me-3"
                  src="assets/icons/flags/id.svg"
                  alt="indonesian flag"
                  loading="lazy"
                />
                <span class="hidden lg:block">Indonesian</span>
              </div>
            }
          </button>
          <div
            #languageDropdownMenu
            class="hidden my-4 z-50 text-base list-none bg-white divide-y divide-gray-100 rounded-md shadow dark:bg-gray-700"
          >
            <ul class="py-2 font-medium w-max" role="none">
              <li class="hover:cursor-pointer">
                <a
                  (click)="setLanguage('en')"
                  class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                  role="menuitem"
                >
                  <div class="inline-flex items-center">
                    <img
                      class="w-5 h-5 rounded-full me-3"
                      src="assets/icons/flags/en.svg"
                      alt="uk flag"
                      loading="lazy"
                    />
                    English
                  </div>
                </a>
              </li>
              <li class="hover:cursor-pointer">
                <a
                  (click)="setLanguage('de')"
                  class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                  role="menuitem"
                >
                  <div class="inline-flex items-center">
                    <img
                      class="w-5 h-5 rounded-full me-3"
                      src="assets/icons/flags/de.svg"
                      alt="german flag"
                      loading="lazy"
                    />
                    Deutsch
                  </div>
                </a>
              </li>
              <li class="hover:cursor-pointer">
                <a
                  (click)="setLanguage('fa')"
                  class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                  role="menuitem"
                >
                  <div class="inline-flex items-center">
                    <img
                      class="w-5 h-5 rounded-full me-3"
                      src="assets/icons/flags/fa.svg"
                      alt="iranian"
                      loading="lazy"
                    />
                    فارسی
                  </div>
                </a>
              </li>
              <li class="hover:cursor-pointer">
                <a
                  (click)="setLanguage('id')"
                  class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                  role="menuitem"
                >
                  <div class="inline-flex items-center">
                    <img
                      class="w-5 h-5 rounded-full me-3"
                      src="assets/icons/flags/id.svg"
                      alt="indonesian flag"
                      loading="lazy"
                    />
                    Indonesia
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="hidden md:flex md:flex-row items-center mx-2">
          <button
            (click)="_pageService.setTheme()"
            id="theme-toggle-page"
            type="button"
            aria-label="set the theme of the page"
            class="text-gray-600 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-600 rounded-md text-sm px-4 py-2"
          >
            <ng-container *ngIf="(selectedColortheme$ | async) === 'dark'; else lightTemplate1">
              <ng-icon class="mt-1" name="bootstrapSunFill"></ng-icon>
            </ng-container>
            <ng-template #lightTemplate1>
              <ng-icon class="mt-1" name="bootstrapMoonFill"></ng-icon>
            </ng-template>
        </button>
        </div>
      </div>
      <div
        class="hidden md:flex items-center justify-between w-full md:w-auto md:order-1 mx-auto"
        dir="ltr"
      >
        <ul
          class="flex flex-col mt-4 font-medium md:flex-row md:mt-0 md:space-x-8 rtl:space-x-reverse"
        >
          <li class="cursor-pointer">
            <a
              [routerLink]="['.']"
              [relativeTo]="activatedRoute"
              class="inline-block py-2 px-3 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-600 md:p-0 md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700"
              [ngClass]="
                (currentLocation |async) === ''
                  ? 'text-blue-600 dark:text-blue-500'
                  : 'text-black dark:text-white'
              "
            >
              {{ 'HEADER.HOME' | translate }}
            </a>
          </li>
          <li class="cursor-pointer">
            <a
              [routerLink]="['jobs']"
              [relativeTo]="activatedRoute"
              class="inline-block py-2 px-3 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-600 md:p-0 md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700 cursor-pointer"
              [ngClass]="
                (currentLocation |async) === 'jobs'
                  ? 'text-blue-600 dark:text-blue-500'
                  : 'text-black dark:text-white'
              "
            >
              {{ 'HEADER.JOBS' | translate }}
            </a>
          </li>
          <li class="cursor-pointer">
            <a
              [routerLink]="['employees']"
              [relativeTo]="activatedRoute"
              class="inline-block py-2 px-3 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-600 md:p-0 md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700 cursor-pointer"
              [ngClass]="
                (currentLocation |async) === 'employees'
                  ? 'text-blue-600 dark:text-blue-500'
                  : 'text-black dark:text-white'
              "
            >
              {{ 'HEADER.EMPLOYEES' | translate }}
            </a>
          </li>
          @if ((activeLanguage | async) == 'de') {
            <li class="cursor-pointer">
              <a
                [routerLink]="['employers']"
                [relativeTo]="activatedRoute"
                class="inline-block py-2 px-3 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-600 md:p-0 md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700 cursor-pointer"
                [ngClass]="
                  (currentLocation |async) === 'employers'
                    ? 'text-blue-600 dark:text-blue-500'
                    : 'text-black dark:text-white'
                "
              >
                {{ 'HEADER.EMPLOYERS' | translate }}
              </a>
            </li>
          }
          <li class="cursor-pointer">
            <a
              [routerLink]="['about-us']"
              [relativeTo]="activatedRoute"
              aria-label="Learn more about our team and mission"
              class="inline-block py-2 px-3 border-b border-gray-100 hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-600 md:p-0 md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700 cursor-pointer"
              [ngClass]="
                (currentLocation |async) === 'about-us'
                  ? 'text-blue-600 dark:text-blue-500'
                  : 'text-black dark:text-white'
              "
            >
              {{ 'HEADER.ABOUT-US' | translate }}
            </a>
          </li>
        </ul>
      </div>
      <div
        class="hidden md:flex md:flex-row items-center md:order-2 space-x-1 md:space-x-2 rtl:space-x-reverse"
      >
        <a
          [routerLink]="['/auth', 'login']"
          class="text-gray-800 bg-gray-100 dark:text-black hover:bg-gray-300 hover:dark:text-white focus:ring-4 focus:ring-gray-300 font-medium rounded-md text-sm px-4 py-2 md:px-5 md:py-2.5 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800 cursor-pointer"
        >
          {{ 'HEADER.LOGIN' | translate }}
        </a>
        <a
          [routerLink]="['/auth', 'register']"
          class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-sm px-4 py-2 md:px-5 md:py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 cursor-pointer"
        >
          {{ 'HEADER.REGISTER' | translate }}
        </a>
      </div>
      <div
        class="flex flex-row w-auto order-1 items-center justify-between md:hidden ml-auto mr-0"
      >
        <div class="text-center">
          <button
            #navbarDrawerOpenButton
            (click)="openDrawerMenu()"
            class="text-black dark:text-white focus:ring-4 focus:ring-gray-300 font-medium rounded-md text-sm px-3 py-2.5 focus:outline-none dark:focus:ring-gray-800"
            type="button"
          >
            <span class="sr-only">Open main menu</span>
            <ng-icon name="heroBars3" class="text-2xl"></ng-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Drawer Menu -->
    <div
      #navbarDrawerMenu
      id="page-drawer-Menu"
      class="fixed z-[1000] h-[98dvh] p-4 transition-transform translate-x-[1000%] bg-gray-100 w-60 dark:bg-gray-900 m-2 rounded-2xl border-[1px] border-gray-300 dark:border-gray-700"
      tabindex="-1"
      aria-labelledby="drawer-js-label"
    >
      <div class="flex flex-col">
        <div class="flex flex-row items-center justify-center">
          <a
            [routerLink]="['.']"
            [relativeTo]="activatedRoute"
            class="flex items-center space-x-3 ml-8 mr-auto"
          >
            <img
              src="assets/logo/almanjobs-logo-primary.svg"
              class="h-10 w-10"
              alt="Almanjobs Logo"
              loading="lazy"
            />
          </a>
          <button
            #navbarDrawerCloseButton
            (click)="closeDrawerMenu()"
            type="button"
            class="text-white bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-md text-sm w-8 h-8 mr-4 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
          >
            <ng-icon
              name="heroXMark"
              class="scale-[2] text-black dark:text-white"
            ></ng-icon>
            <span class="sr-only">Close menu</span>
          </button>
        </div>
        <div class="flex flex-col py-4 min-w-[8rem] m-auto">
          <ul class="space-y-2 font-medium mt-6 min-w-[12rem]" dir="ltr">
            <li>
              <a
                [routerLink]="['']"
                [relativeTo]="activatedRoute"
                (click)="closeDrawerMenu()"
                class="inline-block py-1 px-3 w-full rounded-md hover:bg-gray-50 md:hover:bg-transparent md:hover:text-blue-600 md:p-0 md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent cursor-pointer"
                [ngClass]="
                  (currentLocation |async) === ''
                    ? 'text-blue-600 dark:text-blue-500'
                    : 'text-black dark:text-white'
                "
                aria-current="page"
              >
                {{ 'HEADER.HOME' | translate }}
              </a>
            </li>
            <li>
              <a
                [routerLink]="['jobs']"
                [relativeTo]="activatedRoute"
                (click)="closeDrawerMenu()"
                class="inline-block py-1 px-3 w-full rounded-md hover:bg-gray-50 md:hover:bg-transparent md:hover:text-blue-600 md:p-0 md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent cursor-pointer"
                [ngClass]="
                  (currentLocation |async) === 'jobs'
                    ? 'text-blue-600 dark:text-blue-500'
                    : 'text-black dark:text-white'
                "
                aria-current="page"
              >
                {{ 'HEADER.JOBS' | translate }}
              </a>
            </li>
            <li>
              <a
                [routerLink]="['employees']"
                [relativeTo]="activatedRoute"
                (click)="closeDrawerMenu()"
                class="inline-block py-1 px-3 w-full rounded-md hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-600 md:p-0 md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700 cursor-pointer"
                [ngClass]="
                  (currentLocation |async) === 'employees'
                    ? 'text-blue-600 dark:text-blue-500'
                    : 'text-black dark:text-white'
                "
              >
                {{ 'HEADER.EMPLOYEES' | translate }}
              </a>
            </li>
            @if ((activeLanguage | async) == 'de') {
              <li>
                <a
                  [routerLink]="['employers']"
                  [relativeTo]="activatedRoute"
                  (click)="closeDrawerMenu()"
                  class="inline-block py-1 px-3 w-full rounded-md hover:bg-gray-50 md:hover:bg-transparent md:border-0 md:hover:text-blue-600 md:p-0 md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent dark:border-gray-700 cursor-pointer"
                  [ngClass]="
                    (currentLocation |async) === 'employers'
                      ? 'text-blue-600 dark:text-blue-500'
                      : 'text-black dark:text-white'
                  "
                >
                  {{ 'HEADER.EMPLOYERS' | translate }}
                </a>
              </li>
            }
            <li>
              <a
                [routerLink]="['about-us']"
                [relativeTo]="activatedRoute"
                (click)="closeDrawerMenu()"
                aria-label="Learn more about our team and mission"
                class="inline-block py-1 px-3 w-full rounded-md hover:bg-gray-50 md:hover:bg-transparent md:hover:text-blue-600 md:p-0 md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-blue-500 md:dark:hover:bg-transparent cursor-pointer"
                [ngClass]="
                  (currentLocation |async) === 'about'
                    ? 'text-blue-600 dark:text-blue-500'
                    : 'text-black dark:text-white'
                "
                aria-current="page"
              >
                {{ 'HEADER.ABOUT-US' | translate }}
              </a>
            </li>
          </ul>
          <ul class="space-y-2 font-medium mt-6 min-w-[12rem]">
            <li>
              <hr class="h-px my-4 bg-gray-200 border-0 dark:bg-gray-700" />
            </li>
            <li>
              <div class="flex flex-row justify-center">
                <div
                  class="flex flex-row items-center mx-2 rtl:space-x-reverse"
                >
                  <button
                    [disabled]="(currentLocation |async) === 'employers'"
                    type="button"
                    #languageDropdownMobileButton
                    class="inline-flex items-center justify-center font-medium px-4 py-2 text-sm text-black dark:text-white rounded-md cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-white"
                    [ngClass]="{
                      'bg-gray-100 dark:bg-gray-700':
                      (currentLocation |async) === 'employers'
                    }"
                  >
                    <div
                      id="tooltipContent"
                      #tooltipContent
                      role="tooltip"
                      class="tooltip invisible absolute z-10 inline-block rounded-lg bg-gray-900 px-3 py-2 text-sm font-medium text-white opacity-0 shadow-sm transition-opacity duration-300 dark:bg-gray-700"
                    >
                      {{ tooltipLanguageButtonDisabledReason }}
                      <div class="tooltip-arrow" data-popper-arrow></div>
                    </div>
                    @if((activeLanguage | async) === 'fa'){
                      <div class="inline-flex items-center">
                        <img
                          class="w-5 h-5 rounded-full lg:me-3"
                          src="assets/icons/flags/fa.svg"
                          alt="iranian flag"
                          loading="lazy"
                        />
                        <span class="hidden lg:block">فارسی</span>
                      </div>
                    } @else if((activeLanguage | async) === 'de'){
                      <div class="inline-flex items-center">
                        <img
                          class="w-5 h-5 rounded-full lg:me-3"
                          src="assets/icons/flags/de.svg"
                          alt="german flag"
                          loading="lazy"
                        />
                        <span class="hidden lg:block">Deutsch</span>
                      </div>
                    } @else if((activeLanguage | async) === 'en') {
                      <div class="inline-flex items-center">
                        <img
                          class="w-5 h-5 rounded-full lg:me-3"
                          src="assets/icons/flags/en.svg"
                          alt="uk flag"
                          loading="lazy"
                        />
                        <span class="hidden lg:block">English</span>
                      </div>
                    } @else if((activeLanguage | async) === 'id') {
                      <div class="inline-flex items-center">
                        <img
                          class="w-5 h-5 rounded-full lg:me-3"
                          src="assets/icons/flags/id.svg"
                          alt="uk flag"
                          loading="lazy"
                        />
                        <span class="hidden lg:block">Indonesian</span>
                      </div>
                    }
                  </button>
                  <div
                    #languageDropdownMobileMenu
                    class="hidden my-4 z-50 text-base list-none bg-white divide-y divide-gray-100 rounded-md shadow dark:bg-gray-700"
                  >
                    <ul class="py-2 font-medium" role="none">
                      <li class="hover:cursor-pointer">
                        <a
                          (click)="setLanguage('en')"
                          class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                          role="menuitem"
                        >
                          <div class="inline-flex items-center">
                            <img
                              class="w-5 h-5 rounded-full me-3"
                              src="assets/icons/flags/en.svg"
                              alt="uk flag"
                              loading="lazy"
                            />
                            English
                          </div>
                        </a>
                      </li>
                      <li class="hover:cursor-pointer">
                        <a
                          (click)="setLanguage('de')"
                          class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                          role="menuitem"
                        >
                          <div class="inline-flex items-center">
                            <img
                              class="w-5 h-5 rounded-full me-3"
                              src="assets/icons/flags/de.svg"
                              alt="german flag"
                              loading="lazy"
                            />
                            Deutsch
                          </div>
                        </a>
                      </li>
                      <li class="hover:cursor-pointer">
                        <a
                          (click)="setLanguage('fa')"
                          class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                          role="menuitem"
                        >
                          <div class="inline-flex items-center">
                            <img
                              class="w-5 h-5 rounded-full me-3"
                              src="assets/icons/flags/fa.svg"
                              alt="iranian flag"
                              loading="lazy"
                            />
                            فارسی
                          </div>
                        </a>
                      </li>
                      <li class="hover:cursor-pointer">
                        <a
                          (click)="setLanguage('id')"
                          class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                          role="menuitem"
                        >
                          <div class="inline-flex items-center">
                            <img
                              class="w-5 h-5 rounded-full me-3"
                              src="assets/icons/flags/id.svg"
                              alt="iranian flag"
                              loading="lazy"
                            />
                            Indonesian
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="inline-block h-auto w-0.5 self-stretch bg-neutral-200 opacity-100 dark:opacity-50 py-2"
                ></div>
                <div class="flex flex-row items-center mx-2">
                  <button
                    id="theme-toggle-sm-page"
                    (click)="_pageService.setTheme()"
                    type="button"
                    class="text-gray-600 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-600 rounded-md text-sm px-4 py-2"
                  >
                    <ng-container *ngIf="(selectedColortheme$ | async) === 'dark'; else lightTemplate2">
                      <ng-icon class="mt-1" name="bootstrapSunFill"></ng-icon>
                    </ng-container>
                    <ng-template #lightTemplate2>
                      <ng-icon class="mt-1" name="bootstrapMoonFill"></ng-icon>
                    </ng-template>
                  </button>
                </div>
              </div>
            </li>
            <li>
              <hr class="h-px my-4 bg-gray-200 border-0 dark:bg-gray-700" />
            </li>
            <li>
              <div class="md:hidden flex flex-row w-full">
                <a
                  [routerLink]="['/auth', 'login']"
                  (click)="closeDrawerMenu()"
                  class="text-gray-800 bg-gray-100 dark:text-black hover:bg-gray-300 hover:dark:text-white focus:ring-4 focus:ring-gray-300 font-medium rounded-md text-sm px-4 py-2 md:px-5 md:py-2.5 dark:hover:bg-gray-700 focus:outline-none dark:focus:ring-gray-800 w-full text-center cursor-pointer"
                >
                  {{ 'HEADER.LOGIN' | translate }}
                </a>
              </div>
            </li>
            <li>
              <div class="md:hidden flex flex-row w-full">
                <a
                  [routerLink]="['/auth', 'register']"
                  (click)="closeDrawerMenu()"
                  class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-md text-sm px-4 py-2 md:px-5 md:py-2.5 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 w-full text-center cursor-pointer"
                >
                  {{ 'HEADER.REGISTER' | translate }}
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</header>
